import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { seoMeta, canonicalLink } from "@/lib/content-defaults";
import { Route as rootRoute } from "./__root";

// El contenido real vive en index-page.tsx y se descarga aparte (code-split) — así visitar
// cualquier otra página pública no baja el bundle del home (ver mismo criterio en staff.tsx).
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  head: () => ({
    meta: seoMeta({
      title: "Clases de Calistenia en Santiago | Calistenia Progresiva",
      description: "Clases de calistenia en Ñuñoa y San Miguel con metodología progresiva, estructurada y guiada. Agenda tu primera clase.",
      // "/" explícito (no el default "") para que el canonical, el og:url y la URL del home en
      // sitemap.xml usen el mismo formato con barra final — antes el canonical quedaba sin barra
      // y no coincidía con el sitemap, inconsistencia que Search Console reporta como error.
      path: "/",
    }),
    links: [canonicalLink("/")],
  }),
  component: lazyRouteComponent(() => import("./index-page"), "Home"),
});
